export enum EAuthenticationAction {
  route = "route",
  internal = "internal"
}